// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LatLng$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/entity/LatLng.mjs";

function initial_address(param) {
  return {
          landmark: "",
          location: LatLng$PorterinFeature.initial_lat_lng(undefined)
        };
}

export {
  initial_address ,
}
/* No side effect */
